import React from 'react';
import './styles.sass'

export const Stepper = ({ steps, filledSteps, selectedStep }: { steps: Record<string, string>, filledSteps: number, selectedStep: number }) => {

  const stepClass = (stepIndex: number) => {
    let className = 'step';

    if (stepIndex === selectedStep) {
      className += ' current';
    }
    
    if (filledSteps + 1 >= stepIndex) {
      className += ' filled';
    };

    return className;
  }

  const spacerClass = (stepIndex: number) => {
    let className = 'spacer';

    if (filledSteps > stepIndex - 1) {
      className += ' filled';
    };

    return className;
  }

  return (
    <div className='stepper'>
      {
        Object.values(steps).map((step, index) =>
        <React.Fragment key={step}>
          <div className={stepClass(index + 1)}>
            <span className='number'>{ index + 1 }</span>
            <span className='step-name'>{step}</span>
          </div>
          {index < Object.values(steps).length - 1 && <span className={spacerClass(index + 1)}></span>}
        </React.Fragment>)
      }
    </div>
  )
}
